import React from 'react';
import { splitNewLine, urlify } from './string';

const returnKey = (string) => {
	let code = 0;

	for (let i = 0; i < string.length; i += 1) {
		code = (code * 31) + string.charCodeAt(i);
		code &= code;
	}

	return code;
};

const newLine = (string, split = '\n') => string.split(split).map((item, k) => (k === 0 ? item : [<br />, item]));

const addLinks = (string, split = true) => {
	string = String(string);
	const parts = split ? splitNewLine(string) : string;

	return parts.map((p) => {
		if (p === '') return null;

		const email = p.match(/\b[a-z0-9.@\-_]+@[a-z0-9.@\-_]+\b/i);
		if (email) return <a href={`mailto:${email[0].toLowerCase()}`} target="_blank" rel="noopener noreferrer">{ `${email[0]}\n` }</a>;

		const link = p.match(/^\b[a-z0-9.@\-_]{3,}(\.[a-z]{2,})+\b/i);
		if (link) return <a href={`https://${link[0].toLowerCase()}`} target="_blank" rel="noopener noreferrer">{ `${link[0]}\n` }</a>;

		return <>{ `${p}\n` }</>;
	});
};

const addLists = (string) => {
	string = String(string);
	const parts = splitNewLine(string);
	const groups = [
		/*
		{
			ul: [],
		},
		'string',
		{
			ol: [],
		},
		...
		*/
	];

	parts.forEach((p) => {
		let currentItem = groups;
		if (/^\W\s\w/.test(p)) {
			// Is a ul item
			if (!groups.slice(-1)[0] || !groups.slice(-1)[0].ul) groups.push({ ul: [] });
			currentItem = groups.slice(-1)[0].ul;
			p = p.replace(/^\W\s/, '');
		}
		if (/^\d\.?\s\w/.test(p)) {
			// Is a ol item
			if (!groups.slice(-1)[0] || !groups.slice(-1)[0].ol) groups.push({ ol: [] });
			currentItem = groups.slice(-1)[0].ol;
			p = p.replace(/^\d\.?\s/, '');
		}
		currentItem.push(p);
	});

	return groups.map((g, i) => {
		if (typeof g === 'object') {
			const ListType = Object.keys(g)[0];
			return (
				<ListType key={g[ListType].reduce((acc, item) => `${acc}-${urlify(item.slice(0, 5))}`, '')}>
					{
						g[ListType].map((item) => <li key={urlify(item.slice(0, 50))}>{ item }</li>)
					}
				</ListType>
			);
		}
		return <span key={g || i}>{ g }</span>;
	});
};

export { newLine, returnKey, addLinks, addLists };
